module.exports = __webpack_public_path__ + "images/avatars/male/6.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/avatars/male/6.png
// module id = 7UG8
// module chunks = 151